// extracted by mini-css-extract-plugin
export var author = "lpCompetitorQuote-module--author--6b95f";
export var authorName = "lpCompetitorQuote-module--authorName--43e67";
export var card = "lpCompetitorQuote-module--card--b107b";
export var cardContent = "lpCompetitorQuote-module--cardContent--6f570";
export var cards = "lpCompetitorQuote-module--cards--5e883";
export var glowSvg = "lpCompetitorQuote-module--glowSvg--5f5b0";
export var quoteIcon = "lpCompetitorQuote-module--quoteIcon--82f74";
export var quoteText = "lpCompetitorQuote-module--quoteText--5c71e";